module.exports = __webpack_public_path__ + "static/media/UBCStudentHealthBG.02ae9574.jpg";